// extracted by mini-css-extract-plugin
export var container = "_a9-0";
export var icon = "_a9-1";
export var text = "_a9-2";